var _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomatedTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#f0f0f0"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 68,
    textAnchor: "middle",
    fontSize: 65,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: "bold",
    fill: "#000"
  }, "A")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatedTag);
export default __webpack_public_path__ + "static/media/automated-tag.afb97716af8f4ac6e9bb9526a7a9326c.svg";
export { ForwardRef as ReactComponent };